var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoiFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 19.5,
    stroke: "#19C48F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.25 22.1751C41.1503 23.2722 42.7282 24.8502 43.8253 26.7505C44.9224 28.6507 45.5 30.8063 45.5 33.0005C45.5 35.1947 44.9224 37.3503 43.8253 39.2505C42.7281 41.1508 41.1501 42.7287 39.2499 43.8258C37.3496 44.9229 35.194 45.5005 32.9998 45.5004C30.8056 45.5004 28.65 44.9228 26.7498 43.8256C24.8496 42.7285 23.2716 41.1505 22.1745 39.2502C21.0775 37.3499 20.4999 35.1943 20.5 33.0001L20.5063 32.5951C20.5763 30.4363 21.2044 28.3326 22.3295 26.4889C23.4547 24.6451 25.0383 23.1244 26.9261 22.075C28.8139 21.0255 30.9414 20.4831 33.1013 20.5007C35.2611 20.5182 37.3795 21.0951 39.25 22.1751ZM36.125 34.2501C35.6277 34.2501 35.1508 34.4477 34.7992 34.7993C34.4475 35.1509 34.25 35.6278 34.25 36.1251C34.25 36.6224 34.4475 37.0993 34.7992 37.4509C35.1508 37.8026 35.6277 38.0001 36.125 38.0001C36.6223 38.0001 37.0992 37.8026 37.4508 37.4509C37.8025 37.0993 38 36.6224 38 36.1251C38 35.6278 37.8025 35.1509 37.4508 34.7993C37.0992 34.4477 36.6223 34.2501 36.125 34.2501ZM37.6337 28.3664C37.3993 28.132 37.0815 28.0004 36.75 28.0004C36.4185 28.0004 36.1007 28.132 35.8663 28.3664L28.3663 35.8664C28.1386 36.1021 28.0126 36.4179 28.0154 36.7456C28.0183 37.0734 28.1497 37.3869 28.3815 37.6186C28.6132 37.8504 28.9268 37.9819 29.2545 37.9847C29.5822 37.9875 29.898 37.8616 30.1337 37.6339L37.6337 30.1339C37.8681 29.8995 37.9997 29.5816 37.9997 29.2501C37.9997 28.9187 37.8681 28.6008 37.6337 28.3664ZM29.875 28.0001C29.3777 28.0001 28.9008 28.1977 28.5492 28.5493C28.1975 28.9009 28 29.3778 28 29.8751C28 30.3724 28.1975 30.8493 28.5492 31.2009C28.9008 31.5526 29.3777 31.7501 29.875 31.7501C30.3723 31.7501 30.8492 31.5526 31.2008 31.2009C31.5525 30.8493 31.75 30.3724 31.75 29.8751C31.75 29.3778 31.5525 28.9009 31.2008 28.5493C30.8492 28.1977 30.3723 28.0001 29.875 28.0001Z",
    fill: "#19C48F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoiFeature);
export default __webpack_public_path__ + "static/media/roi_feature.0f2b03cdb37252992409d8cd406bd850.svg";
export { ForwardRef as ReactComponent };